import React from 'react'
import styles from './Synchronize.module.scss'
import { ReactComponent as Calendar } from 'components/CRM/UI/icons/calendar.svg'
import googleIcon from 'components/CRM/UI/icons/google_icon.png'
import { Link } from 'react-router-dom'

const Synchronize = ({ link, translate }) => {
  return (
    <>
      <div className={styles.notification}>
        <Calendar className={styles.icon} />
        <div className={styles.text}>
          {translate?.modal_message_synchronization}
        </div>
      </div>
      <Link to={link} className={styles.button}>
        <img src={googleIcon} alt='icon' />
        {translate?.button_sync_with_google}
      </Link>
    </>
  )
}

export default Synchronize
